/**
 * 微信热点
 */
"use strict";
angular.module("weixinChannelHotSpotsModule", []).
controller("weixinChannelHotSpotsCtrl", ["$scope", "trsHttpService", "dateFilter", function($scope, trsHttpService, dateFilter,) {
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.status = {
            noInfo: false,
            areaTypeName: '',
            whichTabShow: '',
            jumpToPageNum: 1,
        };
        $scope.data = {
            weixinHotTypes: [],
            areaRelateLists: []
        };
        $scope.page = {
            "STARTPAGE": 1,
            "PAGESIZE": 10
        };
    }

    /**
     * [initData description]  初始化数据
     * @return {[type]} [description]
     */
    function initData() {
        requestNavigation();
    }

    /**
     * [requestNavigation description]获取导航栏
     * @return {[type]} [description]
     */
    function requestNavigation() {
         var params = {
            typeid: "widget",
            serviceid: "channelWeixinHotpointMgr",
            modelid: "getMedias"
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get").then(function(data) {
            if (data.MAPRESULT.STATUS && data.MAPRESULT.STATUS == 'success') {
                $scope.data.weixinHotTypes = data.MAPRESULT.CONTENT;
                $scope.status.whichTabShow = $scope.data.weixinHotTypes[0].searchSiteName;
                requestWeixinData();
            }
        });
    }

    /**
     * [requestWeixinData description]获取微信列表数据
     * @return {[type]} [description]
     */
    function requestWeixinData() {
        var params = {
            typeid: "widget",
            serviceid: "channelWeixinHotpointMgr",
            modelid: "getArticles",
            site_name: $scope.status.whichTabShow,
            page_size: $scope.page.PAGESIZE,
            page_no: $scope.page.STARTPAGE-1
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
            if (data.MAPRESULT.STATUS && data.MAPRESULT.STATUS == 'success') {
                var reqData = data.MAPRESULT.CONTENT;
                $scope.data.areaRelateLists = reqData.PAGEITEMS;
                $scope.page = {
                    STARTPAGE: reqData.PAGEINDEX+1,
                    PAGESIZE: reqData.PAGESIZE,
                    ITEMCOUNT: reqData.TOTALITEMCOUNT,
                    PAGECOUNT: reqData.TOTALPAGECOUNT
                }
                $scope.status.noInfo = false;
                if (reqData.length == 0) {
                    $scope.status.noInfo = true;
                }
            }
        });
    }

    /**
     * [jumpOriText description]跳转原文
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
    $scope.jumpOriText = function(item) {
        window.open(item.URLNAME);
    }

    /**
     * [clickTitletab 点击微信标题]
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    $scope.clickTitletab = function(data) {
        $scope.status.whichTabShow = data.searchSiteName;
        $scope.page.STARTPAGE = 1; // 重置页码
        requestWeixinData();
    }

    /**
     * [pageChanged description]分页请求
     * @return {[type]} [description]
     */
    $scope.pageChanged = function() {
        $scope.status.jumpToPageNum = $scope.page.STARTPAGE;
        requestWeixinData();
    };

    $scope.jumpToPage = function() {
        if ($scope.status.jumpToPageNum > $scope.page.PAGECOUNT) {
            $scope.status.jumpToPageNum = $scope.page.PAGECOUNT;
        }
        $scope.page.STARTPAGE = $scope.status.jumpToPageNum;
        requestWeixinData();
    };

}]);